module.exports = __webpack_public_path__ + "static/card_back.b866f133.png";